// extracted by mini-css-extract-plugin
export default {"field":"CompanyRoles_field__ny9IS"};